import { CustomFieldRetrieveReadable, Type83fEnum } from '@crm/api'
import { getInitialValue, getLabel, getValidationRules } from '@crm/utils'
import { useLocales } from '@shared/locales'
import { DEFAULT_DATE_FORMAT } from '@shared/utils'
import { Checkbox, DatePicker, Form, Input, InputNumber, Select } from 'antd'
import { DefaultOptionType } from 'antd/es/select'

const getOptions = (options?: DefaultOptionType[]) => {
  return options?.map((option) => ({
    label: option?.value,
    value: option?.label
  }))
}

const renderField = (
  props: Partial<CustomFieldRetrieveReadable>,
  currentLang: string,
  disabled?: boolean
) => {
  switch (props?.type) {
    case Type83fEnum.BOOLEAN:
      return (
        <Checkbox disabled={disabled}>{getLabel(props, currentLang)}</Checkbox>
      )
    case Type83fEnum.SELECT:
      return (
        <Select
          disabled={disabled}
          options={getOptions(props?.options)}
          allowClear
          placeholder={getLabel(props, currentLang)}
        />
      )
    case Type83fEnum.MULTISELECT:
      return (
        <Select
          mode="multiple"
          disabled={disabled}
          options={getOptions(props?.options)}
          allowClear
          placeholder={getLabel(props, currentLang)}
          maxTagCount={2}
        />
      )
    case Type83fEnum.NUMBER:
      return (
        <InputNumber
          disabled={disabled}
          min={props?.validation_rules?.min}
          max={props?.validation_rules?.max}
          className="w-full"
        />
      )
    case Type83fEnum.DATE:
      return (
        <DatePicker
          className="w-full"
          format={DEFAULT_DATE_FORMAT}
          disabled={disabled}
        />
      )
    case Type83fEnum.TEXT:
      return (
        <Input placeholder={getLabel(props, currentLang)} disabled={disabled} />
      )
  }
}

type Props = {
  name?: string[]
  disabled?: boolean
} & CustomFieldRetrieveReadable

export const CustomField = ({
  id,
  name = ['custom_field_values'],
  disabled = false,
  ...props
}: Props) => {
  const { currentLang } = useLocales()

  const label =
    props?.type === Type83fEnum.BOOLEAN
      ? undefined
      : getLabel(props, currentLang?.value)

  return (
    <Form.Item
      name={[...name, String(id)]}
      label={label}
      valuePropName={
        props?.type === Type83fEnum.BOOLEAN ? 'checked' : undefined
      }
      initialValue={getInitialValue(props)}
      rules={getValidationRules(props)}
    >
      {renderField(props, currentLang?.value, disabled)}
    </Form.Item>
  )
}
